/**
 * Mobil header zil butonu ile {@link PriceAlarmBox} içindeki toggle akışını bağlar.
 * Context kullanmadan; mount olan kutu handler'ı kaydeder, header sadece tetikler.
 */

let toggleHandler = null;

export function registerPriceAlarmToggleHandler(fn) {
  toggleHandler = fn ?? null;
}

export function triggerPriceAlarmToggleFromHeader() {
  toggleHandler?.();
}
